import { makeStyles } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Divider, Grid, Paper, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import CommonUtil from "../../Util/CommonUtils";
import { ReactComponent as Step1 } from "../../assets/v4/Union228.svg";
import { ReactComponent as Step3 } from "../../assets/v4/Union229.svg";
import { ReactComponent as Step2 } from "../../assets/v4/Union230.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import api from "../../config/http-common";
import { getAllSites } from "../../slices/Site/SiteSlice";
import { addDevice } from "../../slices/Zlink Device Management/DeviceSlice";
import { ThemeContext } from "../../theme/ThemeContext";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
}));
export default function ZlinkAddDeviceInfo(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { darkMode } = useContext(ThemeContext);
  const [siteData, setSiteData] = useState([]);
  const [siteId, setSiteId] = React.useState("");
  const [zoneList, setZoneList] = React.useState([]);
  const [zones, setZones] = React.useState([]);
  const [state, setState] = React.useState({
    deviceId: "",
    sn: "",
    siteId: "",
    zoneId: "",
    deviceName: "b012",
    deviceAlias: "",
  });
  const [error, setError] = React.useState({
    deviceId: "",
    sn: "",
    siteId: "",
    zoneId: "",
    deviceName: "",
    deviceAlias: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    const inputValue = event.target.value;
    const pattern = /^[a-zA-Z0-9\s]*$/;
    if (pattern.test(inputValue)) {
      setState({
        ...state,
        [name]: inputValue,
      });
      setError({
        ...error,
        [name]: false,
      });
    } else {
      setError({
        [name]: true,
      });
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    loadSites();
    loadZones();
  }, []);

  const loadSites = () => {
    const query = {
      page: 1,
      rowsPerPage: 10000,
      name: "",
    };
    dispatch(getAllSites(query))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") {
          setSiteData(data.data.site);
        } else {
          setSiteData([]);
        }
      });
  };

  const loadZones = () => {
    api
      .securedAxios()
      .get(`/api/v2.0/zlink/zones`)
      .then((response) => {
        if (response.data.code === "LMSI0000")
          setZoneList(response.data.data.zone);
      });
  };

  useEffect(() => {
    if (!CommonUtil.isEmptyArray(zoneList)) {
      const zoneFilter = zoneList.filter((zone) => {
        return zone.siteId === siteId;
      });
      setZones(zoneFilter);
    }
  }, [siteId]);

  const handleSubmit = () => {
    dispatch(addDevice(state))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4077") {
          Toast(data.message, "success");
          history.push("/vis/device-list");
        } else {
          Toast(data.message, "error");
        }
      });
  };

  const handleClose = () => {
    history.push("/vis/device-list");
  };
  return (
    <>
      <HeaderToolbar title={t("Add Device")} back_button={true} />
      <Paper
        sx={{
          backgroundColor: darkMode ? "#0E2A41" : "#FFFFFF",
          padding: "2rem",
          borderRadius: "8px",
          overflowX: "hidden",
          height: "calc(100vh - 160px)",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Grid item sx={{ width: "30%" }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: darkMode ? "#FFFFFF" : "#000000",
                fontWeight: 500,
              }}
            >
              {t("TurnontheDevice")}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: darkMode ? "#DDDDDD" : "#707070",
                opacity: 0.8,
              }}
            >
              {t("DEVICEINFOO3")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "60px",
              }}
            >
              <Step1 />
            </Box>
          </Grid>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              height: "auto",
              borderColor: darkMode ? "#FFFFFF" : "#00000033",
              marginX: "16px",
            }}
          />
          <Grid item sx={{ width: "30%" }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                color: darkMode ? "#FFFFFF" : "#000000",
                fontWeight: 500,
              }}
            >
              {t("ConfigureTheNetwork")}
            </Typography>
            <Tooltip title={`${t("DEVICEINFOO4")}`} arrow>
              <Typography
                variant="body2"
                sx={{
                  color: darkMode ? "#DDDDDD" : "#707070",
                  opacity: 0.8,
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 3,
                  overflow: "hidden",
                  wordBreak: "break-word",
                }}
              >
                {t("DEVICEINFOO4")}
              </Typography>
            </Tooltip>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "40px",
              }}
            >
              <Step3 />
            </Box>
          </Grid>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              height: "auto",
              borderColor: darkMode ? "#FFFFFF" : "#00000033",
              marginX: "16px",
            }}
          />
          <Grid item sx={{ width: "30%" }}>
            <Tooltip title={`${t("DEVICEINFOO5")}`} arrow>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  color: darkMode ? "#FFFFFF" : "#000000",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {t("DEVICEINFOO5")}
              </Typography>
            </Tooltip>
            <Tooltip
              title={`${t("DEVICEINFOO6")} "${t("DEVICEINFOO7")}"`}
              arrow
            >
              <Typography
                variant="body2"
                sx={{
                  color: darkMode ? "#DDDDDD" : "#707070",
                  opacity: 0.8,
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 3,
                  overflow: "hidden",
                  wordBreak: "break-word",
                }}
              >
                {t("DEVICEINFOO6")} "{t("DEVICEINFOO7")}"
              </Typography>
            </Tooltip>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "39px",
              }}
            >
              <Step2 />
            </Box>
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          spacing={2}
          marginTop={5}
        >
          <Grid item xs={12} sm={4}>
            <CustomTextfield
              error={error.sn}
              required
              fullWidth
              name="sn"
              label={t("DeviceSN")}
              variant="outlined"
              value={state.sn}
              handleChange={handleChange}
              inputProps={{ className: classes.input }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <CustomTextfield
              error={error.deviceAlias}
              required
              fullWidth
              name="deviceAlias"
              label={t("Device Name")}
              variant="outlined"
              value={state.deviceAlias}
              handleChange={handleChange}
              inputProps={{ className: classes.input }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              fullWidth
              disablePortal
              options={siteData}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{
                "& .MuiAutocomplete-popupIndicator": {
                  color: "#808080 !important",
                  opacity: "0.9",
                  marginRight: "10px",
                },
              }}
              renderInput={(params) => (
                <CustomTextfield
                  {...params}
                  required
                  label={t("BindSite")}
                  helperText={error.siteId && t("SiteRequired")}
                />
              )}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState((prev) => ({ ...prev, siteId: newValue.id }));
                  setSiteId(newValue.id);
                } else {
                  setState((prev) => ({ ...prev, siteId: "" }));
                }
              }}
              ListboxProps={{ style: { maxHeight: "150px" } }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              fullWidth
              disablePortal
              options={zones}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{
                "& .MuiAutocomplete-popupIndicator": {
                  color: "#808080 !important",
                  opacity: "0.9",
                  marginRight: "10px",
                },
              }}
              renderInput={(params) => (
                <CustomTextfield
                  {...params}
                  label={t("BindZone")}
                  error={error.zoneId}
                  helperText={error.zoneId && t("ZoneRequired")}
                />
              )}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState((prev) => ({ ...prev, zoneId: newValue.id }));
                }
              }}
              ListboxProps={{ style: { maxHeight: "90px" } }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
            paddingRight: "38px",
          }}
        >
          <Grid item>
            <CancelButtons onClick={handleClose}>
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("COMMON008")}
              </Typography>
            </CancelButtons>
          </Grid>
          <Grid item>
            <SubmitButtons onClick={handleSubmit} type="submit">
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("COMMON007")}
              </Typography>
            </SubmitButtons>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
